/**
 * SpeedmasterLoyalty.Shopping.js — Shopping entry point
 *
 * Adds loyalty/rewards context to header views via addToViewContextDefinition.
 * Legacy pricing modules (Cart.Summary, ProductViews.Price) self-execute on load.
 */
define('SpeedmasterLoyalty.Shopping', [
    'SpeedmasterLoyalty.Config',

    // Legacy modules — self-executing, apply prototype mutations on load.
    'Cart.Summary.View.Ext',
    'ProductViews.Price.View.Ext'
], function(Config) {
    'use strict';

    /* ------------------------------------------------------------------ */
    /*  Private helpers                                                     */
    /* ------------------------------------------------------------------ */

    /**
     * Shared header/menu context — used by Header.Profile.View
     * and Header.Menu.View (identical data).
     */
    function _headerProfileContext() {
        var profile = Config.getProfile();
        var isAuthenticated = profile.isLoggedIn || profile.isRecognized;
        var currentpricelevel = isAuthenticated
            ? Config.getCurrentPriceLevel(profile.priceLevel)
            : null;

        return {
            customerid: profile.firstName,
            name: profile.lastName,
            currentpricelevel: currentpricelevel,
            points: profile.points,
            showExtendedMenu: !profile.isLoading && isAuthenticated,
            isRecognized: profile.isRecognized
        };
    }

    /* ------------------------------------------------------------------ */
    /*  mountToApp                                                         */
    /* ------------------------------------------------------------------ */

    return {
        mountToApp: function mountToApp(container) {
            /** @type {LayoutComponent} */
            var layout = container.getComponent('Layout');

            if (!layout) { return; }

            /* ========================================================== */
            /*  HEADER LOYALTY CONTEXT — addToViewContextDefinition        */
            /* ========================================================== */

            // ── Header.Profile.View (5 properties) ──────────────────────

            layout.addToViewContextDefinition(
                'Header.Profile.View', 'customerid', 'string',
                function() { return _headerProfileContext().customerid; }
            );
            layout.addToViewContextDefinition(
                'Header.Profile.View', 'name', 'string',
                function() { return _headerProfileContext().name; }
            );
            layout.addToViewContextDefinition(
                'Header.Profile.View', 'currentpricelevel', 'object',
                function() { return _headerProfileContext().currentpricelevel; }
            );
            layout.addToViewContextDefinition(
                'Header.Profile.View', 'points', 'number',
                function() { return _headerProfileContext().points; }
            );
            layout.addToViewContextDefinition(
                'Header.Profile.View', 'showExtendedMenu', 'boolean',
                function() { return _headerProfileContext().showExtendedMenu; }
            );
            layout.addToViewContextDefinition(
                'Header.Profile.View', 'isRecognized', 'boolean',
                function() { return _headerProfileContext().isRecognized; }
            );

            // ── Header.Menu.View (same properties) ────────────────────

            layout.addToViewContextDefinition(
                'Header.Menu.View', 'customerid', 'string',
                function() { return _headerProfileContext().customerid; }
            );
            layout.addToViewContextDefinition(
                'Header.Menu.View', 'name', 'string',
                function() { return _headerProfileContext().name; }
            );
            layout.addToViewContextDefinition(
                'Header.Menu.View', 'currentpricelevel', 'object',
                function() { return _headerProfileContext().currentpricelevel; }
            );
            layout.addToViewContextDefinition(
                'Header.Menu.View', 'points', 'number',
                function() { return _headerProfileContext().points; }
            );
            layout.addToViewContextDefinition(
                'Header.Menu.View', 'showExtendedMenu', 'boolean',
                function() { return _headerProfileContext().showExtendedMenu; }
            );
            layout.addToViewContextDefinition(
                'Header.Menu.View', 'isRecognized', 'boolean',
                function() { return _headerProfileContext().isRecognized; }
            );

            /* ========================================================== */
            /*  LEGACY MODULES                                             */
            /*  Loaded as define() dependencies — self-execute on load.    */
            /*                                                             */
            /*  - Cart.Summary.View.Ext (totalSavings, totalPoints)        */
            /*  - ProductViews.Price.View.Ext (priceDiff, points, isPDP)   */
            /* ========================================================== */
        }
    };
});
